import React from 'react';
import { Link } from 'react-router';


const Projectcta = () => {
  return (
    <>
     <section className="cta cta-bg pos-rel pt-115 pb-90">
            <div
              className="cta-bg-inner ukiyo img-size-1 img-position-l"
              data-u-speed=".6"
              data-background="assets/img/bg/project_bg.jpg"
            ></div>
            <div className="container">
              <div className="row">
                <div className="cta-title text-center mb-75">
                  <h2 className="title">
                    Do You Have Any <br /> <span> Project?</span>
                  </h2>
                  <Link to="/contact">
                    Get In Touch{" "}
                    <span>
                      <img src="assets/img/icon/arrow_right2.svg" alt="" />
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </section>
    </>
  )
}

export default Projectcta
